import { render } from "./SublinkNaveMobi.vue?vue&type=template&id=084c461a&scoped=true"
import script from "./SublinkNaveMobi.vue?vue&type=script&lang=js"
export * from "./SublinkNaveMobi.vue?vue&type=script&lang=js"

import "./SublinkNaveMobi.vue?vue&type=style&index=0&id=084c461a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084c461a"]])

export default __exports__